import Timeline from './view/timeline';
import TimelineItem from './view/timeline-item';

Timeline.Item = TimelineItem;

export default Timeline;
